/**
 * @generated SignedSource<<2e0b39fa22260a499c5ed875407e935b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LogoutInput = {
  clientMutationId?: string | null | undefined;
};
export type Auth_Logout_Mutation$variables = {
  input: LogoutInput;
};
export type Auth_Logout_Mutation$data = {
  readonly logout: {
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type Auth_Logout_Mutation = {
  response: Auth_Logout_Mutation$data;
  variables: Auth_Logout_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LogoutPayload",
    "kind": "LinkedField",
    "name": "logout",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Auth_Logout_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Auth_Logout_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1f92faf672d4868ab3e1d2e0dbe94fcb",
    "id": null,
    "metadata": {},
    "name": "Auth_Logout_Mutation",
    "operationKind": "mutation",
    "text": "mutation Auth_Logout_Mutation(\n  $input: LogoutInput!\n) {\n  logout(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f176d5c8d82fd2aa2f46b07e819f4ad";

export default node;
